import {useEffect, useState} from "react";
import InputField from "../../components/InputField";
import SubmitButton from "../../components/SubmitButton";
import api from "../../api";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import { FaArrowRight } from "react-icons/fa"; // آیکون
import Logo from "../../components/Logo";

export default function UserRegister() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    full_name: "",
    phone_number: "",
    national_code: "",
    employee_code: "",
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
    const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrors({});
    setLoading(true);

    try {
      const submitData = {
        ...formData,
      };
      const response = await api.post("accounts/register/internal/", submitData);

      console.log("ثبت‌نام موفق", response.data);
      localStorage.setItem('accessToken', response.data.tokens.access);
      localStorage.setItem('refreshToken', response.data.tokens.refresh);

      navigate("/");

    } catch (err) {
      if (err.response && err.response.data) {
        setErrors(err.response.data);
      } else {
        alert("خطای شبکه یا سرور");
      }
    } finally {
      setLoading(false);
    }
  };
  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-50 px-4">
      <div className="bg-white p-8 rounded-lg shadow-md w-full max-w-md border text-right">
        <div className="mb-6 text-center relative">
          <Link to={"/"}><Logo /></Link>
          <h1 className="text-xl font-medium text-center mb-6">ثبت نام</h1>
          <Link to="/admin-panel/employee-user-management/"><FaArrowRight className="absolute right-0 top-1/2 -translate-y-1/2"/></Link>
        </div>

          <form className="flex flex-col gap-4" onSubmit={handleSubmit}>
            <InputField
                label="نام و نام خانوادگی"
                name="full_name"
                value={formData.full_name}
                onChange={handleChange}
                error={errors.full_name}
            />
            <InputField
                label="شماره موبایل"
                name="phone_number"
                value={formData.phone_number}
                onChange={handleChange}
                error={errors.phone_number}
            />
            <InputField
                label="کد ملی"
                name="national_code"
                value={formData.national_code}
                onChange={handleChange}
                error={errors.national_code}
            />
              <InputField
                label="کد پرسنلی"
                name="employee_code"
                value={formData.employee_code}
                onChange={handleChange}
                error={errors.employee_code}
            />

            <SubmitButton text={loading ? "در حال ارسال..." : "ثبت نام"}/>
          </form>
        </div>
      </div>
      );
      }